export default __webpack_public_path__ + "static/media/contact.94687a03.png";